// extracted by mini-css-extract-plugin
export var actionButton = "_cj-0";
export var attachmentLine = "_cj-1";
export var fileInput = "_cj-2";
export var fileUploadWrapper = "_cj-4";
export var footer = "_cj-3";
export var modalContent = "_cj-5";
export var paperclip = "_cj-6";
export var quillEditor = "_cj-7";